export default {
  namespaced: true,

  state: {
    order: null,
  },

  getters: {
    get: state => {
      return state.order;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.order = payload;
    },
  },

  actions: {
    async init({commit}) {
      const order = await require('../../../assets/json/order.json');

      // make data a bit more unique
      order.order_id = (new Date()).valueOf();
      order.line_items[0].id = "75d3522a5d0210a1d4" + order.order_id;

      commit('set', order);
    },
  },
};
